import { Component, OnInit } from '@angular/core';
import { RestService } from '../rest.service';

@Component({
  selector: 'app-reservas-parking',
  templateUrl: './reservas-parking.component.html',
  styleUrls: ['./reservas-parking.component.scss']
})
export class ReservasParkingComponent implements OnInit {

  reservas: any[] = [];

  constructor(public rest: RestService) {
    this.GetReservas();
  }

  ngOnInit() {
    setInterval(
      function() { this.GetReservas(); }
      .bind(this), 60000 );
  }


  GetReservas() {
    this.rest.getReservas().subscribe( (data) => {
      this.reservas = data['data'];
    });
  }

  PostChanges(reserva, estado) {
    this.rest.state(reserva, estado)
    .subscribe( (data) => { this.GetReservas(); });
  }

  Pay(reserva,$event) {
    const opcion = confirm('¿Cambiar el precio a ' + $event.target.value + '?');
    if (opcion) {
      this.rest.CustomerPay(reserva.id, $event.target.value)
    .subscribe( (data) => { this.GetReservas(); });
    } else {
      $event.target.value = reserva.precio;
    }

  }

}
